import { ConfirmationService } from 'primeng/api';
import { Component, OnInit, ViewChildren, QueryList, ViewChild, Input } from '@angular/core';
import { ItemConfirmComponent } from '@pages/_components/item-confirm/item-confirm.component';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { MessagesService } from '@core/_services/messages.service';
import { Table } from 'primeng/table';
import { TabPanelHandler } from '@core/_utils/table.utils';
import { CommonService } from '@service/common.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiV6Service } from '@service/apiv6.service';
import { getGroupListData, getUserListData } from '@core/_utils/tools.utils';
import { forkJoin, lastValueFrom, map } from 'rxjs';
import { RequestTools } from '@service/request.tools';
import { Tools } from '@service/tools';
import { IndexedDbService } from '@service/indexeddb.service';
import { addInfosBsk } from '@core/_utils/basket.utils';

@Component({
    selector: 'app-list-baskets',
    templateUrl: './list-baskets.component.html',
    styleUrls: ['./list-baskets.component.scss'],
})
export class ListBasketsComponent extends TabPanelHandler implements OnInit {
    public value = true;
    public itemConfirm: ItemConfirmComponent;
    public dataList = [];
    public activeList = [];
    public groupList = [];
    public userList = [];
    public basketMailList: any[];
    public basketCollectList: any[];
    public basketPublishList: any[];
    public basketActionList: any[];
    public bskType = 'mail';

    protected _isInRangeTimeout: any;

    public listColumns = [];

    @ViewChildren('p-tabPanel:not(:first-child)')
    public itemChildren: QueryList<any>;

    @ViewChild('dt')
    public dataTable: Table;
    public blockEvent = false;

    @Input()
    public entities: Array<any> = [];

    public duplicate = false;

    constructor(
        private api: ApiV6Service,
        public menu: MenuServiceInt,
        private requestTools: RequestTools,
        private tools: Tools,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        protected translate: TranslateService,
        private indexedDbService: IndexedDbService
    ) {
        super(translate);
        this.menu.display = true;
    }

    ngOnInit() {
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Cfb_Name'), field: 'name' },
            { header: this.translate.instant('Cfb_Label'), field: 'label' },
            { header: this.translate.instant('Cfb_Desc'), field: 'desc' },
        ];
    
        this.findAll();
        this.commonService.checkReset();
    }

    setFilteredList(event) {}

    private async findAll() {
        this.dataList = [];
        this.groupList = [];
        this.userList = [];
        let wRes: any = {};
        let wTranfert: any;
        let wBskTransList: any;

        try {
            wRes.data = await lastValueFrom(this.readBasketsData());
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
            return;
        }
        wBskTransList = this.requestTools.getBskTransList(wRes.data.getBasketList);
        wTranfert = this.tools.getBasketTransfert(wBskTransList, null, 
            false, null, null, null);

        this.groupList = [...getGroupListData(wRes.data.getGroupList.GroupList)];
        this.userList = [...getUserListData(wRes.data.getUserList.UserList)];

        this.basketMailList = wTranfert.wBasketMailList;
        this.basketCollectList = wTranfert.wBasketCollectList;
        this.basketPublishList = wTranfert.wBasketPublishList;
        this.basketActionList = wTranfert.wBasketActionList;
        this.onFilterClick('mail');
    }

    private readBasketsData() {
        return forkJoin([
            this.requestTools.getBasketList('*'),
            this.api.execUrlAction('getuserlist', ''),
            this.api.execUrlAction('getgrouplist', ''),]).pipe(
            map(([getBasketList, getUserList, getGroupList,]) => {
                return { getBasketList, getUserList, getGroupList };
            })
        );
    }

    public onFilterClick(event) {
        this.dataList = [];
        this.getFilter(event);
    }

    private getFilter(aType) {
        let wResult = [];
        const type = {
            mail: this.getList(this.basketMailList),
            coll: this.getList(this.basketCollectList),
            publ: this.getList(this.basketPublishList),
            acti: this.getList(this.basketActionList),
        };
        if (type[aType]) {
            wResult = type[aType]();
        }
        this.dataList = wResult.map((item, index) => {
            item.name = item.Information.Name;
            item.label = item.Information.Label;
            item._label = item.Information.Label;
            item.desc = item.Information.Description;
            item.userList = item.Rights.UserList;
            item.groupList = item.Rights.GroupList;
            item.id = index + 1;
            return item;
        });
    }

    private getList(aList) {
        return () => {
            return aList;
        };
    }

    closeTab(event) {
        this.closeTabsheet(event);
        this.index = event.index - 1;
        this.execClose(event);
    }

    validateTab(event) {
        this.refreshData();
        this.closeTab(event);
    }

    private async refreshData() {
        let wDataRequest = {};
        let wKey = '';
        let wRes: any;
        switch (this.bskType) {
            case 'mail': {
                wDataRequest = { typefilter: 'Mail'};
                wKey = 'BasketMailList';
                break;
            }
            case 'coll': {
                wDataRequest = { typefilter: 'Collect'};
                wKey = 'BasketCollectList';
                break;
            }
            case 'publ': {
                wDataRequest = { typefilter: 'Publish'};
                wKey = 'BasketPublishList';
                break;
            }
            case 'acti': {
                wDataRequest = { typefilter: 'Action'};
                wKey = 'BasketActionList';
                break;
            }
        }
        wRes = await lastValueFrom(this.api.execUrlAction('getbasketlistbyuser', wDataRequest));
        await this.indexedDbService.updateDataIndexedDb('bskList', wKey, wRes[wKey]);
        switch (this.bskType) {
            case 'mail': {
                this.basketMailList = [];
                this.basketMailList = addInfosBsk(wRes[wKey]['BasketMail'], 'btMail', null, null, this.api, null, false, null);
                break;
            }
            case 'coll': {
                this.basketCollectList = [];
                this.basketCollectList = addInfosBsk(wRes[wKey]['BasketCollect'], 'btCollect', null, null, this.api, null, false, null);
                break;
            }
            case 'publ': {
                this.basketPublishList = [];
                this.basketPublishList = addInfosBsk(wRes[wKey]['BasketPublish'], 'btPublish', null, null, this.api, null, false, null);
                break;
            }
            case 'acti': {
                this.basketActionList = [];
                this.basketActionList = addInfosBsk(wRes[wKey]['BasketAction'], 'btAction', null, null, this.api, null, false, null);
                break;
            }
        }
        this.onFilterClick(this.bskType);
    }

    addTab(event) {
        this.addToDataList(event);
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    private addToDataList(event) {
        this.dataList.push({
            label: event.data.data.login,
            name: event.data.data.login,
        })
        this.dataList = this.dataList.map((item, index) => {
            item._label = item.name;
            item.id = index + 1;
            return item;
        });        
    }

    deleteTab(event) {
        this.dataList = this.dataList.filter((item) => {
            return item.name !== event.data.login;
        });
        this.dataList = [...this.dataList];
        this.closeTab(event);
    }

    cancelAdd(event) {
        this.closeTabsheet(this._event);
        this.index = this.index - 1;
    }

    handleChange($event) {
        this.index = $event.index;
    }

    confirmDelete(event) {
        this.itemConfirm.confirmAction(
            'delete',
            this.translate.instant('Confirm_DelU', {label: event.data.login}),
            () => {
                this.delete(event);
            }
        );
    }
    
    public delete(event) {

    }

    showDetails(item) {
        item = item.data;
        if (!this.isAlreadySelected(item.id)) {
            this.addElement(item.id, item.name, item.name);
        }
    }

    public clickcolDup(event, aData) {
        if (!this.isAlreadySelected(aData.id)) {
            this.duplicate = true;
        }
    }

    public onLoadItem(event) {
        this.duplicate = false;
    }

    sortReference(event: any): void {}
}
